/**
 * Describes different types of events fired from the promise dialog
 */
export default Object.freeze({
  /**
   * A confirmation or submit response
   */
  OK: 'ok',
  /**
   * Indicating that the dialog should be closed
   */
  Cancel: 'cancel',
})
